

export const dataObject = [

    {
        number: "1",
        title: "Best Together",
        body: "As individuals, we are among the best in our field. As Real Chemistry, we are an all-star team that sees diversity, inclusion and collaboration ​as a competitive advantage."
    },
    {
        number: "2",
        title: "Impact Obsessed", 
        body: "We put ourselves in a position to positively impact companies, directly impact care and leave the world better than we found it.​"
    },
    {
        number: "3",
        title: "Excellence Expected", 
        body: "Of yourself and ​those around you.​ To create a future where everyone has an excellent healthcare experience, we have to be excellent ourselves—in our work, our results and our ability to make ​those around us better.​"
    },
    {
        number: "4",
        title: "Evolve, Always", 
        body: "As healthcare modernizes, the only constant is change. To lead that change, we embrace the need to evolve as a company and as people—even when it’s uncomfortable. "
    },
    {
        number: "5",
        title: "Accountability with an “I”​", 
        body: "There is no royal “we” in accountability. It is a value every single one of us owns, for ourselves. I do my part and then some. I stand up for what I believe. I assume my role in running a financially healthy business.​"
    },
]